export default {
  // --- App / global ---
  app_name: 'SwipeWish TCG',
  ok: 'OK',
  cancel: 'Cancel',
  save: 'Save',
  back: 'Back',
  loading: 'Loading',
  error_generic: 'An error occurred',
  retry: 'Retry',

  // --- Auth ---
  auth_sign_in: 'Sign In',
  auth_sign_up: 'Sign Up',
  auth_email: 'Email',
  auth_password: 'Password',
  auth_username: 'Username',
  auth_username_min: 'Username must be at least 3 characters',
  auth_username_max: 'Username must be at most 20 characters',
  auth_submit_login: 'Sign In',
  auth_submit_register: 'Sign Up',
  auth_tagline: 'Find cards, trade with people nearby.',
  auth_confirm_email: 'Account created. Check your email for confirmation, then sign in. If you don\'t find the email, check the spam folder.',
  auth_error: 'Authentication error',
  auth_show_password: 'Show password',
  auth_hide_password: 'Hide password',
  auth_or_continue_with: 'or continue with',
  auth_google: 'Google',
  auth_facebook: 'Facebook',
  auth_first_name: 'First name',
  auth_last_name: 'Last name',
  auth_first_name_required: 'First name is required',
  auth_last_name_required: 'Last name is required',
  auth_disallowed_words_field: 'The field "{field}" contains words that are not allowed',
  auth_address: 'Address',
  auth_address_placeholder: 'Search by street, city, postcode',
  auth_address_hint: 'Used only to calculate approximate distances.',
  auth_callback_loading: 'Signing you in…',
  auth_callback_redirect_login: 'Redirecting to login…',

  // --- Tabs ---
  tab_discover: 'Discover',
  tab_inventory: 'Binder',
  tab_wishlist: 'Wishlist',
  tab_matches: 'Matches',
  tab_profile: 'Profile',

  // --- Swipe ---
  swipe_set_location_title: 'Set your location',
  swipe_set_location_desc: 'We only show approximate distances. Your exact location is never stored.',
  swipe_enable_geo: 'Enable geolocation',
  swipe_searching: 'Looking for nearby cards',
  swipe_resolving_location: 'Updating your location…',
  swipe_empty_title: 'No cards in range',
  swipe_empty_desc: 'There are no cards to discover within your current range ({radius} km). Try expanding it or check back later.',
  swipe_edit_radius: 'Edit range',
  swipe_filters_button: 'Filters',
  swipe_filters_title: 'Match filters',
  swipe_filters_any: 'Any',
  swipe_filters_requested_only_hint: 'Filters are applied to candidates requested cards (their wishlist).',
  swipe_filters_rarity: 'Rarity',
  swipe_filters_condition: 'Card condition',
  swipe_filters_language: 'Language',
  swipe_filters_grading_company: 'Grading company',
  swipe_filters_grade: 'Grade',
  swipe_filters_rarity_disabled_multi_tcg: 'Rarity disabled: turn off "Multi-TCG matchmaking" in Settings to enable it.',
  swipe_outgoing_match_pending_warning: 'You have outgoing matches in progress: wishlist cards already included in those matches do not generate new matches until the negotiation is closed or cancelled.',
  swipe_free_active_match_cap_warning: 'Maximum of 4 active matches reached',
  swipe_skip: 'Skip',
  swipe_like: 'Like',
  swipe_location_block_title: 'Location unavailable',
  swipe_location_block_desc: 'Geolocation is disabled or no address has been provided.',
  swipe_go_to_settings: 'Go to Settings',
  swipe_slot_block_title: 'Slot limit exceeded',
  swipe_slot_block_desc: 'Slot limit exceeded, activate the Pro subscription or reduce quantities in inventory and wishlist.',
  offline_title: 'Connection unavailable',
  offline_no_connection: 'Internet connection unavailable. It is impossible to access platform features.',

  // --- Match popup ---
  match_title: "It's a Match!",
  match_subtitle: 'You and <strong>{username}</strong> are interested in each other\'s cards. Start chatting to arrange the trade.',
  match_chat: 'Go to match',
  match_continue: 'Keep swiping',
  match_already_title: 'You were just matched',
  match_already_subtitle: '<strong>{username}</strong> just created a match with you. Open incoming matches to continue.',
  match_open_incoming: 'Open incoming matches',
  match_cards_count: '{count} cards in common',
  match_tap_to_view: 'Tap a card for details',
  match_back_to_cards: 'Back to cards',

  // --- Inventory ---
  inv_title: 'My Binder',
  inv_slots: '{used}/{total} slots used',
  inv_slots_unlimited: '{used} slots used',
  inv_go_pro: 'Go Pro',
  inv_empty_title: 'Your binder is empty',
  inv_empty_desc: 'Add your cards to start trading.',
  inv_add: 'Add cards',
  inv_not_tradeable: 'Not tradeable',
  inv_match_locked_warning: 'Card in an active match',

  // --- Wishlist ---
  wish_title: 'Wishlist',
  wish_empty_title: 'Your wishlist is empty',
  wish_empty_desc: 'Save the cards you\'re looking for to get better swipe suggestions.',
  wish_add: 'Add cards',

  // --- Catalog ---
  catalog_title: 'Card Catalog',
  catalog_search: 'Search by name',
  catalog_results: '{count} results',
  catalog_binder: 'Binder',
  catalog_wishlist: 'Wishlist',
  catalog_add: 'Add',
  catalog_added_label: 'Added',
  catalog_remove: 'Remove',
  catalog_added_binder: '"{name}" added to binder',
  catalog_added_wish: '"{name}" added to wishlist',
  catalog_select_tcg: 'Select TCG',

  // --- Matches / Chat ---
  matches_title: 'Your Matches',
  matches_empty_title: 'No matches yet',
  matches_empty_desc: 'Start discovering cards in Discover to get your first match!',
  matches_section_outgoing: 'Outgoing matches',
  matches_section_incoming: 'Incoming matches',
  history_matches_section_outgoing: 'Completed outgoing  matches',
  history_matches_section_incoming: 'Completed incoming matches',
  matches_unread_label: '{count} unread messages',
  chat_placeholder: 'Write a message…',
  matches_confirm: 'Confirm',
  matches_load_error: 'Unable to load matches. Check your connection and try again.',
  matches_load_error_title: 'Match loading error',
  matches_load_retry: 'Retry loading',
  chat_unavailable: 'Cannot send: invalid match or expired session.',
  chat_attachment_unsupported: 'Unsupported attachment format.',
  chat_attachment_too_large: 'File exceeds the 5 MB limit.',
  chat_uploading: 'Uploading attachment…',

  // --- Notifications ---
  notifications_title: 'Notifications',
  notifications_empty: 'No new notifications',
  notification_new_match: 'You have a new match',
  notification_new_message: 'New message',
  notification_image: 'Image',
  notification_trade_proposed: 'Wants to trade with you',
  notification_trade_accepted: 'Accepted your trade',
  notification_trade_cancelled: 'Trade cancelled',
  notification_review_prompt: 'Leave a review on the trade you just completed',
  notifications_view_title: 'Notification center',
  notifications_push_badge_title: 'Push notifications disabled',
  notifications_push_badge_desc: 'Enable push notifications to receive new matches and messages instantly.',
  notifications_push_activate: 'Enable',
  notifications_push_activating: 'Enabling…',
  notifications_push_enabled: 'Push notifications enabled.',
  notifications_push_enable_error: 'Unable to enable push notifications.',

  // --- Reviews ---
  reviews_button: 'Reviews',
  history_leave_review_btn: 'Leave a review',
  reviews_modal_title: 'Reviews of {user}',
  reviews_empty: 'No reviews yet.',
  reviews_count: '{count} reviews',
  review_form_title_outgoing: 'Review {user}',
  review_form_title_incoming: 'Review {user}',
  review_form_rating_label: 'Rating',
  review_form_comment_label: 'Comment',
  review_form_comment_placeholder: 'Write a comment (optional)',
  review_form_submit: 'Send',
  review_form_cancel: 'Cancel',

  // --- Profile ---
  profile_title: 'Profile',
  profile_display_name: 'Display name',
  profile_bio: 'Bio',
  profile_save: 'Save profile',
  profile_saved: 'Profile updated',
  profile_settings: 'Settings',
  profile_help: 'Guide',
  profile_location: 'Location',
  profile_logout: 'Log out',
  profile_info_section: 'Profile information',
  profile_other_section: 'Other',
  profile_change_photo: 'Change photo',
  profile_avatar_alt: 'Profile avatar',

  // --- Help ---
  help_hero_desc: 'The platform built for TCG card collectors who want to trade safely, directly, and without complications.',
  help_in_person_title: 'Why trade in person?',
  help_in_person_desc: 'Shipping brings real risks: cards damaged in transit, lost packages, and scams that are hard to dispute. SwipeWish is designed to remove them.',
  help_in_person_transport_title: 'No transport risk',
  help_in_person_transport_desc: 'see the cards live before handing yours over, with no surprises.',
  help_in_person_direct_title: 'Direct collector-to-collector trades',
  help_in_person_direct_desc: 'no middlemen, no payment platform, no fees.',
  help_in_person_mutual_title: 'Guaranteed mutual value',
  help_in_person_mutual_desc: 'a match appears only when both collectors have something to offer and something to gain.',
  help_in_person_events_title: 'Great for fairs and events',
  help_in_person_events_desc: 'increase your range to find distant collectors and agree on trades before the event.',
  help_sections_title: 'App sections',
  help_section_discover_desc: 'Browse compatible collector profiles. Swipe right (Trade) to show interest, or left (Swipe) to skip. You only see collectors who have cards you want and want cards you have. With a Pro subscription, you can open Filters to narrow down matches.',
  help_section_inventory_desc: 'Your digital binder. Add cards you want to trade with condition, language, grading, and variant. Cards involved in an active match are locked and do not appear to other users.',
  help_section_wishlist_desc: 'The cards you are looking for. The more precise your wishlist is (condition, language, variant), the better the matches suggested by the system will be.',
  help_section_matches_desc: 'Here you find matches you created (Outgoing matches) and matches you received (Incoming matches). Chat, select cards, then send or accept the final trade proposal.',
  help_section_profile_desc: 'Edit your name and location. From here you can access Settings (range, default game, Pro subscription), completed trade history, and Support.',
  help_swipe_title: 'How Swipe works',
  help_swipe_desc: 'The Discover section does not show random cards. The system applies an automatic two-way filter before suggesting any profile.',
  help_swipe_mutual_title: 'Mutual compatibility',
  help_swipe_mutual_desc: 'your wishlist is matched against other collectors binders and, in parallel, their wishlist is matched against your binder. Only mutually useful profiles appear.',
  help_swipe_active_matches_title: 'Active matches excluded',
  help_swipe_active_matches_desc: 'cards already involved in an active match are not shown in Discover. This helps you choose carefully whether to start the match or swipe to the next candidate.',
  help_swipe_radius_title: 'Geographic range',
  help_swipe_radius_desc: 'you only see profiles within the range set in Settings (100 km by default on the Free plan). You can change it anytime from the icon at the top of the Discover tab.',
  help_swipe_pro_filters_title: 'Pro filters',
  help_swipe_pro_filters_desc: 'you can narrow matches by rarity, condition, language, grading company, and grade. Filters are saved on your device and applied to the next search.',
  help_swipe_identity_title: 'Card identity criteria',
  help_swipe_identity_desc: 'the system considers card, condition, language, grading, and variant to keep matches relevant.',
  help_match_title: 'How a Match works',
  help_match_positive_title: 'Positive match',
  help_match_positive_desc: 'match with a compatible profile; the match appears in Outgoing matches.',
  help_match_chat_title: 'Chat',
  help_match_chat_desc: 'agree on how many cards to trade, which cards, and where and when to meet.',
  help_match_proposal_title: 'Formal proposal',
  help_match_proposal_desc: 'the person who started the swipe selects the cards and sends the proposal; the other person accepts or rejects it.',
  help_match_in_person_title: 'In-person trade',
  help_match_in_person_desc: 'meet up, exchange the cards by hand, and the match is closed.',
  help_match_note: 'Cards included in a pending proposal are locked and cannot be selected in other matches until that proposal is resolved.',
  help_pro_title: 'Why go Pro?',
  help_pro_desc: 'SwipeWish Pro unlocks advanced features for collectors who trade frequently, across longer distances, or across multiple games.',
  help_pro_radius_title: 'Range up to 2,000 km',
  help_pro_radius_desc: 'perfect for events, fairs, and conventions outside your area. The Free plan limit is 100 km.',
  help_pro_slots_title: 'Unlimited inventory slots',
  help_pro_slots_desc: 'add all the cards you want without ever hitting the limit.',
  help_pro_three_way_title: 'Three-way trades (A→B→C→A)',
  help_pro_three_way_desc: 'suggestions to close trades that would otherwise stay stuck because there is no direct mutual interest.',
  help_pro_filters_title: 'Advanced Discover filters',
  help_pro_filters_desc: 'narrow your search by rarity, condition, language, grading company, and grade directly from the Filters button.',
  help_pro_multi_tcg_title: 'Multi-TCG search',
  help_pro_multi_tcg_desc: 'extend search to all games at the same time, even outside the default game. When active, the card rarity filter is reset and disabled because rarities are not consistent across different games.',
  help_pro_visibility_title: 'More visibility',
  help_pro_visibility_desc: 'your cards appear earlier in other collectors results, with a Pro badge on your profile.',
  help_pro_nearby_title: 'Real-time nearby trade alerts',
  help_pro_nearby_desc: 'Every 5 minutes SwipeWish looks for compatible trades within 1 km. When it finds one, both of you get a notification: whoever taps first starts the trade and becomes the initiator. If the counterparty is on the Free plan and already has 4 active matches, they will not receive the alert. Requires GPS enabled (also in the background) and push notifications turned on.',

  // --- Nearby trade alerts ---
  nearby_alert_title: 'Nearby trade available',
  nearby_alert_subtitle: '{user} at {distance} km · Tap to start the trade',
  nearby_alert_section_title: 'Near you',
  nearby_alert_claim_cta: 'Start trade',
  nearby_alert_claim_error_already_claimed: 'Another user already started this trade.',
  nearby_alert_claim_error_free_cap: 'The counterparty has reached the Free plan limit of active trades.',
  nearby_alert_push_title: 'Nearby trade available',
  nearby_alert_push_body: 'Tap to start the trade.',
  bg_geo_title: 'SwipeWish',
  bg_geo_notice: 'We keep you posted on nearby trades.',

  // --- Settings ---
  settings_title: 'Settings',
  settings_language: 'Language',
  settings_language_it: 'Italiano',
  settings_language_en: 'English',
  settings_radius: 'Trade range',
  settings_radius_desc: 'We only show cards within {radius} km of you.',
  settings_radius_free: 'The Free plan is limited to 100 km.',
  settings_go_pro: 'Upgrade to SwipeWish Pro',
  settings_pro_desc: 'Range up to 2000 km, unlimited slots and three-way trades.',
  settings_three_way: 'Three-way trades',
  settings_three_way_desc: 'A -> B -> C -> A suggestions to break deadlocks.',
  settings_pro_only: '(Pro only)',
  settings_update_loc: 'Update location',
  settings_update_loc_desc: 'Your exact location is never stored, only an approximation.',

  // --- Subscription ---
  sub_title: 'SwipeWish Pro',
  sub_price: '2.99',
  sub_period: '/month',
  sub_subtitle: 'Unlock advanced search, wider range, and sharper trade controls.',
  sub_already_pro: 'You\'re already a Pro user!',
  sub_pay_app_store: 'Subscribe with Apple App Store',
  sub_pay_app_store_loading: 'Opening App Store',
  sub_pay_play_store: 'Subscribe with Google Play',
  sub_pay_play_store_loading: 'Opening Google Play',
  sub_mobile_only_message: 'Pro purchase is available only on mobile app (iOS/Android) via store.',
  sub_store_redirected_notice: 'Redirecting you to the store to complete payment.',
  sub_store_error: 'Unable to start store payment flow. Please try again.',
  sub_legal: 'By subscribing you accept the Terms of Service. You can cancel anytime from your store account settings.',
  sub_renewal_notice: 'Pro is a monthly subscription with automatic monthly renewal unless cancelled before renewal.',
  sub_features: [
    'Range up to 2,000 km',
    'Real-time nearby trade alerts (≤1 km)',
    'Unlimited inventory slots',
    'Advanced Discover filters: rarity, condition, language, grading and grade',
    'Combined matchmaking across multiple TCGs',
    'Visibility boost for your cards',
    'Three-way trade suggestions (A -> B -> C -> A)',
    'Verified profile badge',
  ],

  // --- Three-way trades ---
  three_title: 'Three-Way Trades',
  three_pro_gate_title: 'Pro Feature',
  three_pro_gate_desc: 'Three-way trade suggestions (A -> B -> C -> A) are only available for Pro users. They help close trades that would otherwise be stuck.',
  three_intro: 'Triangulation suggestions: <strong>you</strong> give a card to <strong>B</strong>, B gives to <strong>C</strong>, C completes the loop back to you.',
  three_empty_title: 'No cycles found',
  three_empty_desc: 'There are no beneficial triangulations within your range at the moment. Add more cards to your wishlist and binder to improve your chances!',
  three_propose: 'Propose this trade',
  three_proposed: 'Three-way trade proposed!',
  three_you: 'You',
  three_distances: 'Distances: {d1}km + {d2}km',

  // --- Card condition ---
  cond_mint: 'M',
  cond_near_mint: 'NM',
  cond_excellent: 'EX',
  cond_good: 'GD',
  cond_light_played: 'LP',
  cond_played: 'PL',
  cond_poor: 'PO',

  // --- Filter bar (Inventory / Wishlist) ---
  filter_name_placeholder: 'Card name',
  filter_number_placeholder: '#  Number',
  filter_expansion_placeholder: 'Expansion',
  filter_results: '{count} of {total}',
  filter_no_results: 'No cards match your search.',

  // --- Radius edit sheet (Discover) ---
  swipe_more_cards: '{n} cards available',
  swipe_details: 'Details',
  swipe_details_count: 'cards',
  swipe_radius_title: 'Search range',
  swipe_radius_apply: 'Apply',
  swipe_radius_loading: 'Applying range and loading new matches…',
  swipe_radius_profile_save_failed: 'Range applied to results, but profile save failed. Please try again.',

  // --- Settings: address update ---
  settings_update_address_desc: 'Change the location used to calculate distances.',
  settings_address_saved: 'Address updated',

  // --- Settings: default game ---
  settings_default_game: 'Default game',
  settings_default_game_desc: 'Pre-selects the game filter in Binder and Wishlist.',
  settings_default_game_none: 'All games',

  // --- Onboarding ---
  onboarding_skip: 'Skip',
  onboarding_next: 'Next',
  onboarding_start: 'Get Started',
  onboarding_slide1_title: 'Trade in Person',
  onboarding_slide1_desc: 'SwipeWish connects TCG collectors in your area. No shipping, no risk: find someone who has your cards, agree via chat, and meet in person.',
  onboarding_slide2_title: 'Your Binder',
  onboarding_slide2_desc: 'Add the cards you want to trade in your Binder. Cards already locked in an active match are automatically blocked and hidden from other users.',
  onboarding_slide3_title: 'Your Wishlist',
  onboarding_slide3_desc: 'Add the cards you\'re looking for to your Wishlist. The system suggests only users where there is mutual interest: you have at least one of their cards and they have at least one of yours.',
  onboarding_slide4_title: 'Match & Meet Up',
  onboarding_slide4_desc: 'When you swipe on a compatible profile, it\'s a Match! Go to the Matches tab, chat to agree, and exchange cards in person — safe and direct, no middlemen.',
  onboarding_slide5_title: 'Find Nearby Collectors',
  onboarding_slide5_desc: 'Enable GPS to discover cards near you. Adjust the search range in Settings: the Pro plan extends it up to 2,000 km. Your exact location is never stored.',

  // --- Swipe stamps ---
  stamp_like: 'MATCH',
  stamp_nope: 'SWIPE',
  stamp_in_wishlist: 'In your wishlist',

  // --- Location source ---
  location_source_gps: 'GPS active',
  location_source_address: 'Using profile address',
  settings_address_geo_hint: 'Used only when device geolocation is not available.',

  // --- Catalog: condition selector ---
  catalog_condition_label: 'Condition',
  catalog_language_label: 'Language',
  catalog_grading_company_label: 'Grading',
  catalog_grading_company_none: 'None',
  catalog_grade_label: 'Grade',
  catalog_grade_placeholder: 'Select',
  catalog_price_label: 'Price',
  catalog_notes_label: 'Notes',
  catalog_notes_placeholder: 'stamped, signed, etc.',

  matches_delete: 'Delete',
  matches_send_trade: 'Send trade',
  matches_waiting_acceptance: 'Waiting',
  matches_accept_trade: 'Accept trade',

  // --- Support ---
  profile_support: 'Support',
  support_title: 'Support',
  support_subject_label: 'Subject',
  support_subject_placeholder: 'Briefly describe your issue',
  support_description_label: 'Description',
  support_description_placeholder: 'Enter all relevant details...',
  support_send: 'Send email',

  // --- Match notifications ---
  matches_trade_sent: 'Proposal sent!',
  matches_trade_accepted: 'Trade accepted!',
  matches_match_deleted: 'Match deleted',
  details_unavailable_section: 'Unavailable cards',
  details_available_section: 'Available cards',
  details_unavailable_committed_badge: 'Unavailable cards are already committed in another match.',
  details_traded_section: 'Traded cards',
  details_not_traded_section: 'Not traded cards',
  matches_details_validation_loading: 'Validating card availability…',
  matches_trade_block_my_inventory: 'One or more cards you are offering are already committed in another pending proposal: you don\'t have enough copies available.',
  matches_trade_block_peer_inventory: 'The other user is already offering one of the requested cards in another pending proposal. Try again later.',
  matches_trade_block_initiator_inventory: 'The user who sent you this proposal no longer has enough copies: the card is already committed in another pending proposal.',
  matches_trade_block_wishlist: 'You already have another pending proposal delivering this card: accepting would exceed your wishlist quantity.',
  matches_trade_block_no_valid_cards: 'You cannot send the proposal: there are no valid available quantities among the selectable cards.',
  matches_no_available_cards: 'There are no available cards',
  matches_chat_hint: 'To chat with a user, tap on the desired match.',

  // --- Pro tier / Multi-TCG / History ---
  profile_pro_status_active: 'Pro subscription active',
  profile_go_pro_badge: 'Go Pro',
  settings_multi_tcg_matching: 'Multi-TCG matchmaking',
  settings_multi_tcg_desc: 'Extends discovery of matches to all TCGs. The Rarity filter is disabled while this option is active.',
  settings_multi_tcg_pro_only: 'Only available with a Pro subscription.',
  settings_pro_membership_title: 'Pro subscription',
  settings_pro_expiry_value: 'Expires on: {date}',
  settings_pro_expiry_unknown: 'Date unavailable',
  settings_pro_cancel_btn: 'Cancel subscription',
  settings_pro_cancel_scheduled: 'Cancellation already scheduled at period end.',
  settings_pro_cancel_confirm_title: 'Confirm cancellation',
  settings_pro_cancel_confirm_message: 'Your Pro plan will remain active until {date}. Continue?',
  settings_pro_cancel_success_title: 'Cancellation scheduled',
  settings_pro_cancel_success_message: 'Your subscription will be cancelled at period end.',
  settings_pro_cancel_failed_message: 'Unable to cancel the subscription. Please try again.',
  settings_pro_cancel_manual_title: 'External cancellation required',
  settings_pro_cancel_manual_message: 'For subscriptions managed by external stores (Apple/Google/PayPal), cancel directly from that provider account.',
  history_title: 'Trade history',
  history_empty: 'No completed trades yet.',
  history_unavailable_card_label: 'Card no longer available',

  // --- Details modal ---
  details_readonly_info: 'Changes to quantities can only be made at the proposal stage and only by the person who initiated the trade',
  details_proposal_sent_info: 'Trade proposal sent, quantities cannot be changed.',
  details_offer: 'Offer',
  details_obtain: 'Obtain',
  details_request: 'Ask',
  details_select_all: 'Select all',
  details_deselect_all: 'Deselect all',

  // --- Landing page ---
  landing_header_features: 'Features',
  landing_header_how_it_works: 'How it works',
  landing_header_download: 'Download',
  landing_header_login: 'Log in',
  landing_hero_badge: 'Available on Android',
  landing_hero_title: 'Trade',
  landing_hero_title_accent: 'cards near you',
  landing_hero_desc: 'Add cards you own and cards you want, browse nearby users\' collections and propose a trade in a few taps.',
  landing_hero_download_btn: 'Download for Android',
  landing_hero_ios_btn: 'App Store — Coming soon',
  landing_hero_footnote: 'Free · No ads · No subscription',
  landing_features_label: 'Features',
  landing_features_title: 'Everything you need',
  landing_features_title_accent: 'to trade cards',
  landing_features_desc: 'SwipeWish TCG connects nearby collectors and makes trades simple and safe.',
  landing_feature_swipe_title: 'Wish matching',
  landing_feature_swipe_desc: 'Automatically matches your wishlists with nearby users\' collections.',
  landing_feature_nearby_title: 'Nearby only',
  landing_feature_nearby_desc: 'Trades happen in person. The search radius is adjustable from 1 to 2000 km.',
  landing_feature_realtime_title: 'Real-time notifications',
  landing_feature_realtime_desc: 'Get an instant notification when someone wants to trade with you.',
  landing_feature_multi_title: 'Multi TCG',
  landing_feature_multi_desc: 'Pokémon, Magic, One Piece and other card games on a single platform.',
  landing_how_label: 'How it works',
  landing_how_title: 'Three steps',
  landing_how_title_accent: 'to the perfect trade',
  landing_how_add_title: 'Add your collection and wishlist',
  landing_how_add_desc: 'Scan or search for cards you own and those on your wishlist.',
  landing_how_find_title: 'Find a match',
  landing_how_find_desc: 'Browse nearby users\' cards: do a match or pass.',
  landing_how_close_title: 'Close the trade',
  landing_how_close_desc: 'Agree on a meeting place via chat and exchange cards in person.',
  landing_download_label: 'Download',
  landing_download_title: 'Start trading',
  landing_download_title_accent: 'today',
  landing_download_desc: 'Download the app for free and start finding trades near you.',
  landing_download_android_req: 'Android 8.0+',
  landing_download_android_status: 'Available',
  landing_download_android_desc: 'Install the APK directly, no Play Store needed. Automatic in-app updates.',
  landing_download_android_btn: 'Download APK',
  landing_download_free: 'Free',
  landing_download_no_ads: 'No ads',
  landing_download_updates: 'Free updates',
  landing_download_ios_req: 'iOS 16+',
  landing_download_ios_status: 'Coming soon',
  landing_download_ios_desc: 'The iOS version is in active development. Join the waitlist to be the first to try it.',
  landing_download_ios_hint: 'Want to be notified?',
  landing_download_ios_contact: 'Contact us',
  landing_modal_aria: 'Download SwipeWish TCG',
  landing_modal_close: 'Close',
  landing_modal_title: 'Android Download',
  landing_modal_subtitle: 'APK file · In-app updates',
  landing_modal_download_btn: 'Download APK',
  landing_modal_downloading: 'Downloading...',
  landing_modal_downloaded: 'Download complete',
  landing_modal_download_error: 'Download failed. Verify the APK file is correctly published and try again.',
  landing_modal_how_to_install: 'How to install',
  landing_modal_step1_title: 'Open the downloaded file',
  landing_modal_step1_desc: 'Find the APK file in your device\'s Downloads folder.',
  landing_modal_step2_title: 'Allow unknown sources',
  landing_modal_step2_desc: 'In settings, enable <em>"Install apps from unknown sources"</em>.',
  landing_modal_step3_title: 'Install the app',
  landing_modal_step3_desc: 'Follow the on-screen installation instructions.',
  landing_modal_step4_title: 'Open it and sign up',
  landing_modal_step4_desc: 'Create your account and start finding trades near you.',
  landing_modal_safety: 'Safe file, verified by the SwipeWish team.',
  landing_footer_tagline: 'The TCG card trading platform for collectors.',
  landing_footer_nav_aria: 'Footer navigation',
  landing_footer_app_section: 'App',
  landing_footer_features: 'Features',
  landing_footer_how_it_works: 'How it works',
  landing_footer_download_android: 'Download for Android',
  landing_footer_support_section: 'Support',
  landing_footer_contact: 'Contact us',
  landing_footer_webapp: 'Access Web App',
  landing_footer_legal_section: 'Legal',
  landing_footer_privacy: 'Privacy Policy',
  landing_footer_terms: 'Terms of Service',
  landing_footer_copyright: '© {year} SwipeWish TCG. All rights reserved.',
  landing_footer_made: 'Made with ♥ for collectors',
} as const;


